export default __webpack_public_path__ + "static/media/penchuk_team_logo.bf32c53e.png";